import {Component, Element, h, Host, Prop, State} from '@stencil/core';

@Component({
  tag: 'bam-session-timeout',
  styleUrl: 'bam-session-timeout.scss',
  shadow: false,
})
export class BamSessionTimeout {

  @Prop() sessionUrl!: string
  @Prop() sessionDuration!: number // Duration in milliseconds
  @Prop() timerInterval: number = 300000 // Timer interval in milliseconds (default 5 minutes)
  @Prop() warningHeadline: string = 'Session will expire in'
  @Prop() warningMessage?: string
  @Prop() expirationHeadline: string = 'Your Session expired at'
  @Prop() expirationMessage?: string
  @Prop() buttonLabel: string = 'Reload Page'

  @State() remainingTime: number = this.timerInterval / 1000 // remaining time in seconds
  @State() countDownStarted: boolean = false
  @State() sessionExpired: boolean = false
  @State() expirationTime: string

  @Element() el: HTMLElement;

  private sessionExpirationTime: number = Date.now() + (this.sessionDuration)

  startSessionTimer = () => {

    const timer = setInterval(() => {
      const currentTime = Date.now();
      if (currentTime >= this.sessionExpirationTime) {
        clearInterval(timer)
        this.sessionExpired = true
      } else if(currentTime >= this.sessionExpirationTime - this.timerInterval) {
        this.startTimeoutCountDown()
      }
      this.sessionUpdatePing(this.sessionUrl)

    }, this.timerInterval)

  }

  async sessionUpdatePing (url: string) {
    try {
      const response = await fetch(url);
      console.info('Session still runing with status: ' + response.status)
    }
    catch(err) {
      console.error("ERROR:", err);
    }
  }

  displayNotification = () => {
    this.startTimeoutCountDown()
  }

  startTimeoutCountDown = () => {
    this.countDownStarted = true
    const countdownInterval = setInterval(() => {
      if (this.remainingTime <= 0) {
        clearInterval(countdownInterval)
      } else {
        this.remainingTime--
      }
    }, 1000);
    this.expirationTime = new Date().toLocaleTimeString()
  }

  convertSeconds = (timeInSec: number) => {
    let minutes = (Math.floor(timeInSec / 60) % 60).toString()
    let seconds = Math.ceil((timeInSec % 60)).toString()

    minutes = minutes.length === 1 ? `0${minutes}` : minutes
    seconds = seconds.length === 1 ? `0${seconds}` : seconds

    return minutes + ':' + seconds
  }

  handleReload = () => {
    location.reload()
  }

  componentDidLoad() {
    this.startSessionTimer()
  }

  render() {
    return (
      <Host>
        <div class={{
          'bam-session-timeout__notification-wrapper': true,
          'mb-large': true,
          'hidden': !this.countDownStarted
        }}>
          <bal-notification color='warning'>
            {!this.sessionExpired &&
              <bal-heading level='h5'>
                {`${this.warningHeadline} ${this.convertSeconds(this.remainingTime)} min`}
              </bal-heading>
            }
            {(!this.sessionExpired && this.warningMessage) &&
              <bal-text space='none'>
                {this.warningMessage}
              </bal-text>
            }
            {this.sessionExpired &&
              <bal-heading level='h5' space='none'>
                {`${this.expirationHeadline} ${this.sessionExpirationTime !== undefined ? new Date(this.sessionExpirationTime).toLocaleTimeString() : ''}`}
              </bal-heading>
            }
            {(this.sessionExpired && this.expirationMessage) &&
              <bal-text space='none'>
                {this.expirationMessage}
              </bal-text>
            }
            {this.sessionExpired && <bal-button color='secondary' class='pt-large' onClick={this.handleReload}>{this.buttonLabel}</bal-button>}
          </bal-notification>
        </div>
      </Host>
    );
  }
}
